<template>
  <router-view></router-view>
</template>

<script>
import { uiHelper, locale } from '@/util'
export default {
  name: 'SportBookLayout',
  metaInfo: {
    title: `${locale.getMessage('meta.sportsbook_title')}`,
    titleTemplate: `%s`,
    meta: [
      { charset: 'utf-8' },
      { name: 'description', content: `${locale.getMessage('meta.sportsbook_description')}` },
      { name: 'keyword', content: `${locale.getMessage('meta.sportsbook_keyword')}` }
    ],
    link: [{ rel: 'canonical', href: `https://www.bhai88.live/en-BD/sportsbook/` }]
  },
  async created() {
    this.metaTag()
  },
  methods: {
    metaTag() {
      // uiHelper.setCanonical('https://www.bhai88.live/en-BD/sportsbook/')
      const currentUrl = window.location.href
      uiHelper.setCanonical(currentUrl)
      // uiHelper.setHreflangLinks('https://www.bhai88.live/sportsbook/')
      // uiHelper.setHreflangLinksen('https://www.bhai88.live/en-BD/sportsbook/')
      // uiHelper.setHreflangLinksbd('https://www.bhai88.live/bn-BD/sportsbook/')
      const domainWithProtocol = currentUrl.split('/')[2]
      const domain = domainWithProtocol.replace(/(^\w+:|^)\/\//, '')
      // const Links = `https://${domain}${window.location.pathname}`;
      // const Linksen = `https://${domain}/en-BD${window.location.pathname}`;
      // const Linksbn = `https://${domain}/bn-BD${window.location.pathname}`;
      const path = window.location.pathname
      const cleanPath = path.replace(/\/(en-BD|bn-BD)/i, '')
      const Links = `https://${domain}${cleanPath}`
      const Linksen = `https://${domain}/en-BD${cleanPath}`
      const Linksbn = `https://${domain}/bn-BD${cleanPath}`
      uiHelper.setHreflangLinks(Links)
      uiHelper.setHreflangLinksen(Linksen)
      uiHelper.setHreflangLinksbd(Linksbn)
    },
    openLoginDialog() {
      this.$parent.openLoginDialog()
    }
  }
}
</script>
